import React from 'react';
import { Helmet } from 'react-helmet';
import LoginHeader from './components/LoginHeader';
import AuthenticationForm from './components/AuthenticationForm';
import SecurityIndicators from './components/SecurityIndicators';

const LoginAuthentication = () => {
  return (
    <>
      <Helmet>
        <title>Login - SecureVault Enterprise</title>
        <meta name="description" content="Secure login to SecureVault Enterprise with WebAuthn passkeys and TOTP authentication" />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-background via-muted/20 to-background">
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[calc(100vh-4rem)]">
              {/* Left Column - Branding & Security Info */}
              <div className="space-y-8">
                <LoginHeader />
                <SecurityIndicators />
              </div>

              {/* Right Column - Authentication Form */}
              <div className="flex items-center justify-center">
                <AuthenticationForm />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="border-t border-border bg-card/50 backdrop-blur-sm">
          <div className="container mx-auto px-4 py-6">
            <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
              <div className="flex items-center space-x-6 text-sm text-muted-foreground">
                <button className="hover:text-foreground transition-smooth">
                  Help Center
                </button>
                <button className="hover:text-foreground transition-smooth">
                  Contact Support
                </button>
                <button className="hover:text-foreground transition-smooth">
                  System Status
                </button>
              </div>
              <div className="text-sm text-muted-foreground">
                © {new Date()?.getFullYear()} SecureVault Enterprise. All rights reserved.
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default LoginAuthentication;